import { forwardRef } from 'react';
import { LucideIcon } from 'lucide-react';

const StackOverflowIcon: LucideIcon = forwardRef((props, ref) => {
  const { color = 'currentColor', size = 24, strokeWidth = 2, className = '', ...otherProps } = props;

  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      className={className}
      {...otherProps}
    >
      <path d="M17.36 20.2v-5.38h1.79V22H3v-7.18h1.8v5.38h12.56M6.77 14.32l.28-1.72 8.43 1.77-.28 1.72-8.43-1.77m1.1-4.04l.85-1.56 7.81 4.19-.85 1.56-7.81-4.19m2.15-3.78l1.3-1.22 6.63 5.72-1.3 1.22-6.63-5.72m4.3-4.1l5.05 6.83-1.59.91-5.05-6.83 1.59-.91m-7.91 14.62h8.67v1.79H6.41v-1.79" />
    </svg>
  );
});

StackOverflowIcon.displayName = 'StackOverflowIcon';

export default StackOverflowIcon;